/*
 * @Author: your name
 * @Date: 2021-05-14 16:06:38
 * @LastEditTime: 2022-03-04 15:32:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /nqc-pc-ui/src/apps/modules/qc-plan/plan/_api/index.js
 */

import { apiService } from '@/frameworks/http/request'
import axios from 'axios'
import store from '@/frameworks/store/index'

let prefix = 'NQCS/DoAction?act='
let HospitalCode = store.state.user.HospitalCode
export function Download(param) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `NQCS/Download?act=ExportZKJH`,
    method: 'post',
    responseType: 'blob',
    data: param,
    timeout: 15 * 60 * 1000
  })
}

/**
 * 获取系统配置
 * @param {*} {Mjdm，Mjlx}
 * @returns
 */
export function GetXTMJList(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetXTMJList`,
    method: 'post',
    data: params
  })
}
/**
 * 获取下发数据
 * @param {*}
 * @returns
 */
export function GetIssuedPlan(params) {
  return apiService({
    url: `${prefix}GetIssuedPlan`,
    method: 'post',
    data: params
  })
}

/**
 * 查询组织结构接口
 * @param { obj : {UserId:'',Zkjb:''} params
 * @returns
 */
export function GetZZjgByZkjbAndUser(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetZZjgByZkjbAndUser`,
    method: 'post',
    data: params
  })
}

// 获取检查表单
export function GetJHJCBDList(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetJHJCBDList`,
    method: 'post',
    data: params
  })
}

/**
 * 获取审核数据
 * @param {*}
 * @returns
 */
export function GetApproveData(params) {
  return apiService({
    url: `${prefix}GetApproveData`,
    method: 'post',
    data: params
  })
}
/**
 * 审核数据
 * @param {*}
 * @returns
 */
export function SaveApproveData(params) {
  return apiService({
    url: `${prefix}SaveApproveData`,
    method: 'post',
    data: params
  })
}

/**
 * 批量审核数据
 * @param {*}
 * @returns
 */
export function BatchSaveApproveData(params) {
  return apiService({
    url: `${prefix}BatchSaveApproveData`,
    method: 'post',
    data: params
  })
}
